import { Module } from "vuex";
import * as firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";

const devicesModule: Module<any, any> = {
  namespaced: false,
  state: {
    devices: [],
    residentDevices: [],
    device: null
  },
  mutations: {
    setDevices(state: any, payload: []) {
      state.devices = payload;
    },
    setResidentDevices(state: any, payload: []) {
      state.residentDevices = payload;
    },
    setDevice(state: any, payload: any) {
      state.device = payload;
    }
  },
  actions: {
    async getDevices({ commit }) {
      const devices = firebase
        .firestore()
        .collection("devices")
        .where("facilityId", "==", this.state.authModule.currentFacility);

      return await devices.get().then(querySnapshot => {
        const deviceList = querySnapshot.docs.map(device => {
          const data = device.data();
          const assignedDateTime = !data.assignedDateTime
            ? null
            : moment(data.assignedDateTime.seconds * 1000).toDate();

          const lastActive = !data.lastActive
            ? null
            : moment(data.lastActive.seconds * 1000).toDate();

          data.lastActive = lastActive;
          data.assignedDateTime = assignedDateTime;
          data.id = device.id;

          return {
            ...data
          };
        });
        commit("setDevices", deviceList);

        return deviceList
      });
    },
    async getDevicesByResidentId({ commit }, residentId) {
      const devicesRef = firebase
        .firestore()
        .collection("devices")
        .where("userId", "==", residentId)
        .where("facilityId", "==", this.state.authModule.currentFacility);

      const querySnapshot = await devicesRef.get();
      const deviceList = querySnapshot.docs.map(device => {
        const data = device.data();
        const assignedDateTime = data.assignedDateTime?.seconds
          ? moment(data.assignedDateTime.seconds * 1000).toDate()
          : null;

        const lastActive = data.lastActive?.seconds
          ? moment(data.lastActive.seconds * 1000).toDate()
          : null;


        return {
          ...data,
          id: device.id,
          assignedDateTime,
          lastActive
        };
      });

      commit("setResidentDevices", deviceList);
    },

    async getDeviceById({ commit }, id) {
      if (!id) {
        commit("setDevice", null);
        return;
      }

      const deviceRef = firebase.firestore().collection("devices").doc(id);
      const querySnapshot = await deviceRef.get();
      const currentRes = querySnapshot.exists ? { ...querySnapshot.data(), id: querySnapshot.id } : null;
      commit("setDevice", currentRes);
    },
    async updateDeviceInfo({ dispatch }, device) {
      console.log("updateDeviceInfo", device)

      return await firebase
        .firestore()
        .collection('devices')
        .doc(device.id)
        .update({
          friendlyName: device.friendlyName
        })
        .then(async () => {
          await dispatch("getDeviceById", device.id)
          return await dispatch('getDevices');
        })
    }

  },
  getters: {}
};

export default devicesModule;
